var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 59,
    viewBox: "0 0 64 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1002 50.0705L44.9156 56.2104C49.867 59.3083 56.3102 58.525 60.3764 54.332L60.5073 54.197C65.2696 49.2872 65.1491 41.4456 60.2393 36.6833C55.9861 32.5589 49.4057 32.0228 44.5437 35.4076L34.909 42.1105C32.0998 44.0657 32.2017 48.2545 35.1022 50.0705H35.1002Z",
    fill: "#F92323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6033 33.1843L12.6911 27.3333C12.2319 24.3807 9.77182 22.1513 6.78812 21.983L6.69254 21.9767C3.19978 21.7773 0.207766 24.4493 0.0103758 27.9441C-0.160003 30.9694 1.83467 33.6934 4.77266 34.4414L10.5905 35.9228C12.288 36.355 13.8734 34.913 13.6033 33.1822V33.1843Z",
    fill: "#F92323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8266 38.4515L42.2725 29.7768C48.5516 25.4009 50.9182 17.2331 47.9553 10.177L47.8597 9.9505C44.3877 1.68507 34.8735 -2.2004 26.6081 1.27159C19.4501 4.27814 15.4234 11.9348 17.0025 19.5353L20.1296 34.5951C21.0417 38.9876 26.1448 41.0176 29.8245 38.4515H29.8266Z",
    fill: "#F92323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebar_logo.99ea31bd332334497b1ef266d9d50a45.svg";
export { ForwardRef as ReactComponent };